module.exports = __webpack_public_path__ + "img/goods04.4c5e65a0.png";